'use client';
import '@/styles/globals.css';
import { Suspense, ReactElement, ReactNode, useState } from 'react';
// import { cn } from '@/lib/utils';
import Header from '@/components/header';
// import Script from 'next/script';
import Navigation from '@/components/navigation';
import RootLoading from './loading';
import Head from 'next/head';
// import dynamic from 'next/dynamic';
import {
  init,
  swipeBehavior,
  viewport,
  miniAppReady,
  mountMiniApp,
} from '@telegram-apps/sdk';
import { useEffect } from 'react';
import { usePageState } from '@/app/hooks/page/usePageState';
import Script from 'next/script';
// import { initTelegramInterceptor } from '@/lib/telegram/telegramInterceptor';
import Providers from '@/components/providers/providers';
// const Providers = dynamic(() => import('@/components/providers/providers'), {
//   ssr: false,
// });
export default function RootLayout({
  children,
}: Readonly<{ children: ReactNode }>): ReactElement {
  const [isTelegram, setIsTelegram] = useState(false);
  usePageState();
  useEffect(() => {
    try {
      init();
      setTimeout(() => {
        mountMiniApp();
        viewport.expand();
        swipeBehavior.mount();
        swipeBehavior.disableVertical();
        miniAppReady();
      }, 10);
    } catch (error) {
      console.log('catch error', error);
    }
    if (typeof window !== 'undefined' && window.Telegram) {
      setIsTelegram(true);
    }
  }, []);

  return (
    <html lang="en" suppressHydrationWarning>
      <Head>
        <title>Fashionist</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <body>
        {/* скрипт ниже важен только для useFetchUser хука, в будущем проверить и устранить */}
        <Script
          src="https://telegram.org/js/telegram-web-app.js"
          strategy="beforeInteractive"
        />
        {isTelegram ? (
          <Providers>
            <Header />
            <main className="h-full min-h-screen w-full">
              <Suspense fallback={<RootLoading />}>{children}</Suspense>
            </main>
            <Navigation />
          </Providers>
        ) : (
          <div>упс</div>
        )}
      </body>
    </html>
  );
}
